import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

function WelcomeNote() {
  const user = useSelector((state: RootState) => state?.user?.user);

  return (
    <div className="mb-2">
      <h2 className="mb-2">Hi, {user?.username}</h2>
      <h5 className="text-body-tertiary fw-semibold">
        Welcome to Unlock Job! We're here to guide you with a roadmap to your
        career goals.
      </h5>
    </div>
  );
}

export default WelcomeNote;
